import { LaunchableService } from "@buf/brevdev_devplane.connectrpc_es/devplaneapi/v1/launchable_connect";
import { Order } from "@buf/brevdev_devplane.bufbuild_es/devplaneapi/v1/launchable_pb";
import { Value } from "@bufbuild/protobuf";
import { createConnectClient } from "../../connect";
import { mapSearchLaunchablesResponse } from "./mappers";

export type { SearchLaunchablesResponse } from "./mappers";

const launchableClient = createConnectClient(LaunchableService);

export interface SearchLaunchablesRequest {
  query: string;
  filters?: Record<string, string[]>;
  sort?: Array<{ field: string; order: "asc" | "desc" }>;
  pageSize?: number;
  cursor?: string;
}

export async function searchLaunchables(request: SearchLaunchablesRequest) {
  const response = await launchableClient.searchLaunchables({
    query: request.query,
    filters: Object.fromEntries(
      Object.entries(request.filters ?? {}).map(([field, values]) => [
        field,
        Value.fromJson(values),
      ]),
    ),
    sort: (request.sort ?? []).map((sort) => ({
      field: sort.field,
      order: sort.order === "asc" ? Order.ASC : Order.DESC,
    })),
    pageSize: request.pageSize ?? 0,
    cursor: request.cursor ?? "",
  });

  return mapSearchLaunchablesResponse(response);
}
